import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import BgImg1 from "../../../images/case-studies/mdrouz/client_back.jpg";
import Img1 from "../../../images/case-studies/mdrouz/client_mob.png";
import Img2 from "../../../images/case-studies/mdrouz/client_mob_1.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Clientbrief = () => {
  return (
    <div className="client_brief" style={{ backgroundImage: `url(${BgImg1})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-xl-7 offset-lg-7">
            <div className="client_head">
              <h2>Client <span>Brief</span></h2>
              <p>The client approached TekRevol with a vision to create a multi-vendor e-commerce mobile app based on established branding guidelines. The client sought a user-friendly platform that would allow consumers in the GCC region to effortlessly browse, select, and purchase clothing articles from various vendors. The emphasis was on creating a sleek and attractive UI with a focus on ease of use and secure payment processing.</p>
            </div>
            <div className="client_case_img ">
              <LazyLoadImage
                src={Img1}
                effect="blur" alt="TekRevol" className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Clientbrief